import api from "../api.js";
import toast from "../toaster.js";

const state = {
    addingUser: false,
    deletingUser: false,
    updatingUser: false,
    userDataLoading: false,
    selectedUserRole: null,
    searchTextUser: '',
    searchTextEndUser: ''
};

const mutations = {
    update(state, changes) {
        Object.assign(state, changes);
    }
};

const getters = {
    allUserList(state, getters, rootState, rootGetters) {
        return rootGetters["admin/userList/getAll"]
    },

    userList(state, getters, rootState, rootGetters) {
        return rootGetters["admin/userList/query"](user => user.role == (state.selectedUserRole || user.role)
            && user.role != 'Enduser'
            && (user.firstName && user.firstName.toLowerCase().indexOf(state.searchTextUser.toLowerCase()) > -1
                || user.lastName && user.lastName.toLowerCase().indexOf(state.searchTextUser.toLowerCase()) > -1
                || user.email && user.email.toLowerCase().indexOf(state.searchTextUser.toLowerCase()) > -1));
    },

    endUserList(state, getters, rootState, rootGetters) {
        return rootGetters["admin/userList/query"](user => user.role == "Enduser"
            && (user.firstName && user.firstName.toLowerCase().indexOf(state.searchTextEndUser.toLowerCase()) > -1
                || user.lastName && user.lastName.toLowerCase().indexOf(state.searchTextEndUser.toLowerCase()) > -1
                || user.email && user.email.toLowerCase().indexOf(state.searchTextEndUser.toLowerCase()) > -1
                || user.userIdentifier && user.userIdentifier.toLowerCase().indexOf(state.searchTextEndUser.toLowerCase()) > -1)
        )
    }
};

const root = { root: true };

const actions = {
    async addUser(context, { vm, data }) {
        context.commit("update", { addingUser: true });

        await api.addUser(data).then((response) => {

            if (response.message == 'user already registered' && response.isDeleted) {

                vm.$bvModal
                    .msgBoxConfirm("Duplicate email found. Do you wish to activate the same ID instead?", {
                        modalClass: "confirm__modal",
                        contentClass: "confirm__modal-contents",
                        title: "Please Confirm",
                        size: "sm",
                        buttonSize: "sm",
                        cancelVariant: "light",
                        okTitle: "YES",
                        cancelTitle: "NO",
                        centered: true,
                    })
                    .then(async (value) => {
                        if (value) {
                            data.id = response.id

                            await api.activateUser(data).then((response) => {

                                context.commit("admin/userList/add", data, root)

                                toast.showToasts(vm, 'User Activated Successfully', 'success');

                                vm.$bvModal.hide('modal-add-user');
                                vm.$bvModal.hide('modal-add-end-user');
                            });
                        }
                    })
                    .catch((err) => {
                        // An error occurred
                    });
            }

            else if (response.message == 'user already registered' && !response.isDeleted) {
                toast.showToasts(vm, "Email already registered.", "danger");
            }

            else {

                data.id = response.userId

                context.commit("admin/userList/add", data, root)

                toast.showToasts(vm, 'User Added Successfully', 'success');
                vm.$bvModal.hide('modal-add-user');
                vm.$bvModal.hide('modal-add-end-user');
            }

        }).catch((error) =>
            toast.showToasts(vm, 'Adding User Failed', 'danger')
        )

        context.commit("update", { addingUser: false });
    },

    async loadUsers(context) {
        context.commit("update", { userDataLoading: true });


        context.commit("update", { searchTextUser: '' });
        context.commit("update", { searchTextEndUser: '' });
        context.commit("update", { selectedUserRole: null });

        if (context.rootGetters["admin/userList/getAll"].length
            && JSON.parse(localStorage.getItem('userInfo')).privileges.indexOf('access-all-tenants') < 0) {
            context.commit("update", { userDataLoading: false });
            return;
        }

        let data = await api.getUsers();

        context.commit("admin/userList/load", data, root);

        context.commit("update", { userDataLoading: false });
    },

    async deleteUser(context, { vm, data }) {
        context.commit("update", { deletingUser: true });

        await api.deleteUser(data.id).then(() => {
            context.commit("admin/userList/delete", data.id, root);
            toast.showToasts(vm, 'User Deleted Successfully', 'success');

        }).catch((error) =>
            toast.showToasts(vm, 'Deleting User Failed.', 'danger')
        )

        context.commit("update", { deletingUser: false });
    },

    async updateUser(context, { vm, data }) {
        context.commit("update", { updatingUser: true });

        await api.updateUser(data).then(() => {
            context.commit("admin/userList/update", data, root);

            toast.showToasts(vm, 'User Updated Successfully', 'success');
            vm.$bvModal.hide('modal-add-user');
            vm.$bvModal.hide('modal-add-end-user');

        }).catch((error) =>
            toast.showToasts(vm, 'Updating User Failed', 'success')
        )

        context.commit("update", { updatingUser: false });
    },

    changeUserRole(context, role) {
        context.commit("update", { selectedUserRole: role });
    },

    searchUser(context, searchText) {
        context.commit("update", { searchTextUser: searchText });
    },

    searchEndUser(context, searchText) {
        context.commit("update", { searchTextEndUser: searchText });
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}